import type { OperationalAlert as OperationalAlertModel } from "@/types/operational-alert";
import { OperationalAlert } from "./operational-alert";

type OperationalAlertViewportProps = {
  alerts: OperationalAlertModel[];
  onDismiss: (id: string) => void;
};

export function OperationalAlertViewport({
  alerts,
  onDismiss,
}: OperationalAlertViewportProps) {
  if (alerts.length === 0) {
    return null;
  }

  return (
    <section
      aria-label="Notificações operacionais"
      className="pointer-events-none fixed right-[max(1rem,env(safe-area-inset-right))] top-[max(5rem,calc(env(safe-area-inset-top)+1rem))] z-[120] flex max-h-[calc(100dvh-6rem)] w-[min(24rem,calc(100vw-2rem))] flex-col gap-3 overflow-y-auto overscroll-contain"
    >
      {alerts.map((alert) => (
        <OperationalAlert key={alert.id} alert={alert} onDismiss={onDismiss} />
      ))}
    </section>
  );
}
